import { httpApi } from '@app/api/http.api'

export const USER_ROLES = [
  'USER',
  'ADMIN',
  'SERVICE_TECHNICIAN',
  'SERVICE_MANAGER',
  'ADMIN_RODO',
  'ADMIN_AUDIT_LOG',
] as const
export const USER_STATUSES = ['ACTIVE', 'BLOCKED'] as const

export type UserRole = (typeof USER_ROLES)[number]
export type UserStatus = (typeof USER_STATUSES)[number]

export type CreateUserPayload = {
  email: string
  password?: string
  firstName: string
  lastName: string
  status: UserStatus
  role: UserRole[]
  position: string
  description: string
  firms: string[]
  devices: string[]
}

export type UserResponse = {
  id: string
  email: string
  firstName: string
  lastName: string
  status: UserStatus
  role: UserRole[]
  position: string
  description: string
  firms?: string[]
  devices?: string[]
}

export type UpdateUserPayload = {
  id: string
  data: CreateUserPayload
}

export type UserPartDataResponse = {
  id: string
  firms: string[]
  devices: string[]
}

const USERS = 'users'

export const getAllUsersTable = (): Promise<UserResponse[]> =>
  httpApi.get<UserResponse[]>(`${USERS}/all-table`).then(({ data }) => data)

export const getUserDetails = (id: string): Promise<UserResponse> =>
  httpApi.get<UserResponse>(`${USERS}/details/${id}`).then(({ data }) => data)

export const getUsersPart = (): Promise<UserPartDataResponse[]> =>
  httpApi.get<UserPartDataResponse[]>(`${USERS}/part-data`).then(({ data }) => data)

export const createUser = (createUserPayload: CreateUserPayload): Promise<string> =>
  httpApi.post<string>(`${USERS}/create-user`, createUserPayload).then(({ data }) => data)

export const updateUser = ({ id, data }: UpdateUserPayload): Promise<void> =>
  httpApi.put<void>(`${USERS}/update/${id}`, data).then(() => undefined)

export const deleteUser = (id: string): Promise<void> => httpApi.delete<void>(`${USERS}/${id}`).then(() => undefined)
